var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('good-base-info',{ref:"coopBaseInfo",attrs:{"goodInfo":_vm.goodInfo}}),_c('a-divider',[_vm._v("商品权益")]),_c('good-auth-info',{ref:"coopAuthInfo"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }